import { Component, ChangeDetectionStrategy, Input } from "@angular/core";
import { ModalService } from "@core-services/modal.service";
import { SegmentService } from "@main-services/segment.service";
import { CustomModal } from "@modules/core/components/base-modals";
import { RudderstackService } from "@main-services/rudderstack.service";

interface Img {
	url: string;
	altKey: string;
}

interface ModalContentI18n {
	modalHeader?: string;
	headline: string;
	description: string;
	topRightButton: string;
	primaryButton: string;
}

interface Button {
	type: "button" | "submit";
	textI18nKey: string;
	action: Function;
	class: string;
}

@Component({
	selector: "app-withdraw-success",
	templateUrl: "./withdraw-success.component.html",
	styleUrls: ["./withdraw-success.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class WithdrawSuccessComponent extends CustomModal {
	@Input() public readonly fiatName: string = null;

	public readonly img: Img = {
		url: "/assets/images/success.svg",
		altKey: "withdraw_successful_title"
	};

	public readonly i18n: ModalContentI18n = {
		modalHeader: "withdrawal_success",
		headline: "withdraw_successful_title",
		description: "withdraw_successful_subtitle",
		topRightButton: "close",
		primaryButton: "done"
	};

	public readonly callToActionButtons: Button[] = [
		{
			type: "button",
			textI18nKey: "done",
			action: () => this.close(),
			class: "btn btn-primary btn-done"
		}
	];

	constructor(
		readonly modalService: ModalService,
		readonly segmentService: SegmentService,
		readonly rudderstackService: RudderstackService
	) {
		super();
		this.segmentService.page({
			name: `Fiat Withdrawal Success`,
			overridePath: `/withdrawal/success`
		});
		this.rudderstackService.page({
			name: `Fiat Withdrawal Success`,
			overridePath: `/withdrawal/success`
		});
	}
}
